"use client";
import React, { useCallback, useEffect, useState } from "react";
import prescriptionLimit from "@/lib/lens/prescriptionLimit";
import { setCookieItem } from "@/lib/commonService";
import { ATTACHMENT_COOKIE_NAME } from "@/config/constConf";
import { useCommonContext, usePackageInfoContext } from "@/src/provider";
import RxForm, { IFormData } from "./RxForm";
import { lensObj, lensPrescription } from "@/store";
import { FmButton, FmDrawer } from "@/ui-component";
import { H5ShowDecenterAlert } from "@/src/components/H5ShowDecenterAlert";
import { getSiteConfiguration } from "@/src/utils/configUtils";
import { useTranslation } from "@/src/i18n/client";
import stl from "./rx.module.scss";
interface IProps {
    // 需要传入的方法和数据
    nextStep: Function;
    glassType?: "prescription" | "nonPrescription";
    productInfo?: Record<string, any>;
    id?: number; // 颜色id
    isHideImgRx: boolean;
    isRiskControl?: any;
}
const defaultProps = {
    glassType: "prescription",
};

const Rx: React.FC<IProps> = (props) => {
    const [notDecen, isDecen] = lensObj.useInstationStore((state) => [
        state.notDecen,
        state.isDecen,
    ]);

    const [getPrescription] = lensPrescription.useLensPrescriptionStore(
        (state) => [state.getPrescription],
    );

    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [title, setTitle] = React.useState("CAN_NOT_BUY_RIMLESS_TIPS");
    const [cancel, setCancel] = React.useState<Function>(() => {});
    const {
        id,
        isRiskControl,
        isHideImgRx,
        productInfo = {},
        nextStep,
    } = props;
    const { host } = useCommonContext();
    const { t } = useTranslation("lens");

    const [resRx, setResRx] = useState("");
    const [h5ShowDecenterAlertRx, setH5ShowDecenterAlertRx] = useState<
        IFormData | undefined
    >();

    const [h5ShowDecenterAlertOpen, setH5ShowDecenterAlertOpen] =
        useState(false);

    useEffect(() => {
        notDecen();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [usage] = usePackageInfoContext((state) => [state.usage]);
    const showCanNotBuy = useCallback(
        (cancel: () => void, title = "CAN_NOT_BUY_RIMLESS_TIPS") => {
            setDialogOpen(true);
            setTitle(t(`lens:${title}`));
            setCancel(cancel);
        },
        [t],
    );
    const submitRx = useCallback(
        (
            res: { rx: string; attachment: any },
            v: IFormData,
            cancel: () => void,
        ) => {
            const { products_frame, master_categories_id } = productInfo;
            const rimless = products_frame;
            const isFolding = master_categories_id == 11; //老花镜Folding

            //判断是否能够购买
            const limit = prescriptionLimit({
                isRless: rimless === "Rimless",
                isFolding: isFolding,
                rx: v,
            });
            if (limit.bool) {
                showCanNotBuy(cancel, limit.title);
            } else {
                setCookieItem(
                    ATTACHMENT_COOKIE_NAME,
                    res.attachment ? res.attachment : "",
                    {
                        path: "/",
                    },
                );
                getPrescription(v, res.rx, res.attachment);
                setH5ShowDecenterAlertOpen(true);
                setResRx(res.rx);
                setH5ShowDecenterAlertRx(v);
            }
        },
        [getPrescription, productInfo, showCanNotBuy],
    );
    return (
        <>
            {h5ShowDecenterAlertOpen && (
                <H5ShowDecenterAlert
                    usage="singleVision"
                    usageDetail={usage.name ?? "distance"}
                    isDecenter={isDecen}
                    nextStep={() => {
                        nextStep(h5ShowDecenterAlertRx, resRx);
                    }}
                    id={id}
                    productInfo={productInfo}
                    rx={h5ShowDecenterAlertRx}
                    open={h5ShowDecenterAlertOpen}
                />
            )}
            <FmDrawer
                closeable
                open={dialogOpen}
                anchor="bottom"
                closeablePosition="right"
                footerClassName={stl["footer-container"]}
                headerChildren
                footer={
                    <>
                        <FmButton
                            onClick={() => cancel()}
                            fullWidth
                            size={"large"}
                        >
                            {t("lens:Cancel")}
                        </FmButton>
                        <FmButton
                            onClick={() =>
                                (location.href = getSiteConfiguration(
                                    "continueShopping",
                                    host,
                                ))
                            }
                            fullWidth
                            size={"large"}
                            variant="outlined"
                            style={{
                                marginTop: "0.2rem",
                            }}
                        >
                            {t("lens:DECENTERED_CANCEL")}
                        </FmButton>
                    </>
                }
            >
                {t(`lens:${title ?? "CAN_NOT_BUY_RIMLESS_TIPS"}`)}
            </FmDrawer>
            <RxForm
                submitRx={submitRx}
                id={id}
                isHideImgRx={isHideImgRx}
                isShowAttachment={isRiskControl}
            />
        </>
    );
};

export default Rx;
